<template>
  <div>
    <!--  -->
    <!-- Entrepreneurial Standing -->
    <SurveyModal
      v-if="user !== undefined"
      @checked="toogleVariable('checkedSurvey', true)"
      @opened="toogleVariable('openedSurvey', true)"
      @closed="toogleVariable('openedSurvey', false)"
      :user="user"
    />
    <!-- Info Filling About -->
    <app-user-onboard-info
      v-if="checkedSurvey && !openedSurvey"
      @checked="toogleVariable('checkedOnboardInfo', true)"
      @opened="toogleVariable('openedOnboardInfo', true)"
      @closed="toogleVariable('openedOnboardInfo', false)"
    />
    <!-- Experience -->
    <app-user-add-exp-modal
      v-if="checkedOnboardInfo && !openedSurvey && !openedOnboardInfo"
      @checked="toogleVariable('checkedExperience', true)"
      @opened="toogleVariable('openedExperience', true)"
      @closed="toogleVariable('openedExperience', false)"
    />
    <!-- Startup Experience -->
    <app-user-startup-skills-modal
      v-if="
        checkedExperience &&
        !openedSurvey &&
        !openedOnboardInfo &&
        !openedExperience
      "
      @checked="toogleVariable('checkedStartupExperience', true)"
      @opened="toogleVariable('openedStartupExperience', true)"
      @closed="toogleVariable('openedStartupExperience', false)"
    />
    <!-- Main Skills -->
    <app-user-main-skills-modal
      v-if="
        checkedStartupExperience &&
        !openedSurvey &&
        !openedOnboardInfo &&
        !openedExperience &&
        !openedStartupExperience
      "
      @checked="toogleVariable('checkedMainSkills', true)"
      @opened="toogleVariable('openedMainSkills', true)"
      @closed="toogleVariable('openedMainSkills', false)"
    />
    <!-- Education -->
    <app-user-add-edu-modal
      v-if="
        checkedMainSkills &&
        !openedSurvey &&
        !openedOnboardInfo &&
        !openedExperience &&
        !openedStartupExperience &&
        !openedMainSkills
      "
      @checked="toogleVariable('checkedEducation', true)"
      @opened="toogleVariable('openedEducation', true)"
      @closed="toogleVariable('openedEducation', false)"
    />
    <!-- Standardized tests -->
    <app-user-standardtests-modal
      v-if="
        checkedEducation &&
        !openedSurvey &&
        !openedOnboardInfo &&
        !openedExperience &&
        !openedStartupExperience &&
        !openedMainSkills &&
        !openedEducation
      "
      @checked="toogleVariable('checkedStandardTest', true)"
      @opened="toogleVariable('openedStandardTest', true)"
      @closed="toogleVariable('openedStandardTest', false)"
    />
    <!-- Bio Info -->
    <app-user-bio-modal
      v-if="
        checkedStandardTest &&
        !openedSurvey &&
        !openedOnboardInfo &&
        !openedExperience &&
        !openedStartupExperience &&
        !openedMainSkills &&
        !openedEducation &&
        !openedStandardTest
      "
      @checked="toogleVariable('checkedBioInfo', true)"
      @opened="toogleVariable('openedBioInfo', true)"
      @closed="toogleVariable('openedBioInfo', false)"
    />
    <!-- Profile Picture -->
    <app-user-avatar-modal
      v-if="
        checkedBioInfo &&
        !openedSurvey &&
        !openedOnboardInfo &&
        !openedExperience &&
        !openedStartupExperience &&
        !openedMainSkills &&
        !openedEducation &&
        !openedStandardTest &&
        !openedBioInfo
      "
      @checked="toogleVariable('checkedAvatar', true)"
      @opened="toogleVariable('openedAvatar', true)"
      @closed="toogleVariable('openedAvatar', false)"
    />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import SurveyModal from "@/shared/components/survey-module/survey.modal.vue";

@Options({
  components: {
    SurveyModal,
  },
})
export default class extends Vue {
  /**
   * @user info
   */
  get user() {
    return this.$store.state.account.user;
  }
  /**
   * Modals check
   */
  openedSurvey = false;
  openedOnboardInfo = false;
  openedExperience = false;
  openedStartupExperience = false;
  openedMainSkills = false;
  openedEducation = false;
  openedStandardTest = false;
  openedBioInfo = false;
  openedAvatar = false;
  /**
   *
   */
  checkedSurvey = false;
  checkedOnboardInfo = false;
  checkedExperience = false;
  checkedStartupExperience = false;
  checkedMainSkills = false;
  checkedEducation = false;
  checkedStandardTest = false;
  checkedBioInfo = false;
  checkedAvatar = false;
  /**
   * @toogles values to change
   */
  toogleVariable(vr: string, value: boolean) {
    console.log("vr=", vr, " value=", value);
    this[vr] = value;
  }
}
</script>

<style lang="scss"></style>
